import * as React from "react";
const MiniHaircutMale2 = ({ color }) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="468 50 200 320">
		<title>{"coiffure m 2"}</title>
		<g id="Calque_1" data-name="Calque 1">
			<rect fill="none" width={1080} height={1920} />
		</g>
		<g id="coiffures">
			<path
				fill={color}
				stroke="black"
				strokeWidth="0.25"
				d="M562.76,88.35s-65.53-2.18-80.82,50.24c8.74,63.35,10.92,65.53,10.92,65.53s0,74.27,2.19,78.64,34.95,43.69,54.61,48.06a40.48,40.48,0,0,0,26.21,0c19.66-4.37,52.42-43.69,54.61-48.06s2.18-78.64,2.18-78.64,2.19-2.18,10.92-65.53C628.29,86.17,562.76,88.35,562.76,88.35Zm21.85,205.33c-2.19,4.37-6.56,6.55-8.74,4.37-6.55-8.74-13.11-4.37-13.11-4.37s-6.55-4.37-13.1,4.37c-2.19,2.18-6.56,0-8.74-4.37s0-19.66,6.55-24a20.43,20.43,0,0,1,15.29-2.18,20.42,20.42,0,0,1,15.29,2.18C584.61,274,586.79,289.31,584.61,293.68Zm34.95-45.87c0,4.37-15.29,28.4-21.85,28.4-8.73-19.66-21.84-21.85-35-21.85s-26.21,2.19-35,21.85c-6.55,0-21.84-24-21.84-28.4s-2.18-52.43-2.18-52.43,10.92-13.1,10.92-19.65-2.19-10.93,2.18-15.3,13.11,0,19.66,0,21.84,2.19,26.21,2.19,19.66-2.19,26.22-2.19,15.29-4.36,19.65,0,2.19,8.74,2.19,15.3,10.92,19.65,10.92,19.65S619.56,243.44,619.56,247.81Z"
			/>
		</g>
	</svg>
);
export default MiniHaircutMale2;
